import { createBrowserRouter } from 'react-router-dom';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import RatingSentencesEdit from '../pages/RatingSentencesEdit';
import StudentDetail from '../pages/StudentDetail';
import Students from '../pages/Students';
import ProtectedRoute from './ProtectedRoute';
import { Paths } from './paths';

const router = createBrowserRouter([
  {
    path: Paths.Login,
    element: <Login />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: Paths.Root,
        element: <Students />,
      },
      {
        path: Paths.Students,
        element: <Students />,
      },
      {
        path: Paths.StudentDetail,
        element: <StudentDetail />,
      },
      {
        path: Paths.RatingSentencesEdit,
        element: <RatingSentencesEdit />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export default router;
